import { useMemo } from "react";

import { SelectOption } from "../../../components/newUI/select";
import { getInitials } from "../../../constants/constants";
import { useGetUsersQuery } from "../../../slices/UserSlice";

/** Team members as options for the role window's member list. */
export const useRoleUserOptions = (orgId?: string) => {
  const { data: users, isLoading } = useGetUsersQuery(orgId || "", {
    skip: !orgId,
  });

  const userOptions = useMemo<SelectOption[]>(
    () =>
      (users || []).map((roleUser) => ({
        value: roleUser.id,
        label:
          [roleUser.userProfile?.firstName, roleUser.userProfile?.lastName]
            .filter(Boolean)
            .join(" ") || "Unknown User",
        avatar: {
          id: roleUser.id,
          color: roleUser.userProfile?.color,
          label: getInitials(
            roleUser.userProfile?.firstName || "",
            roleUser.userProfile?.lastName || "",
          ),
        },
      })),
    [users],
  );

  return { userOptions, isLoadingUsers: isLoading };
};
